"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomStatusDisplayOrientation = void 0;
var __1 = require("../..");
var components_1 = require("../../components");
var button_1 = require("../../components/button/button");
var RoomStatusDisplayOrientation;
(function (RoomStatusDisplayOrientation) {
    RoomStatusDisplayOrientation["Horizontal"] = "Horizontal";
    RoomStatusDisplayOrientation["Vertical"] = "Vertical";
})(RoomStatusDisplayOrientation || (exports.RoomStatusDisplayOrientation = RoomStatusDisplayOrientation = {}));
var MeetingPlacardPage = /** @class */ (function (_super) {
    __extends(MeetingPlacardPage, _super);
    function MeetingPlacardPage(api, eventId, passKey) {
        var _this = _super.call(this, __1.PageTypes.RoomDisplayPage, 'Room Status Display') || this;
        _this.api = api;
        _this.eventId = eventId;
        _this.passKey = passKey;
        _this.loadVenues = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.api.getVenuesByPasskey(this.eventId, this.passKey)];
                    case 1:
                        _a._venues = _b.sent();
                        this._venueFields = this._venues.map(function (venue) {
                            var venueField = new components_1.CheckBoxField(venue.id.toString(), venue.name, false, null, true);
                            venueField.observationProvider.observe(_this.venueSelectionChanged, components_1.FieldActions.ValueChanged);
                            return venueField;
                        });
                        this.syncSelectedVenueIds();
                        this.observationProvider.notifyObservers(__1.RoomStatusDisplayPageActions.Loaded);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.venueSelectionChanged = function () {
            if (_this.isBulkUpdatingVenueFields) {
                return;
            }
            _this.syncSelectedVenueIds();
            _this.observationProvider.notifyObservers(__1.RoomStatusDisplayPageActions.Loaded);
        };
        _this.syncSelectedVenueIds = function () {
            _this.form.model.venueIds = _this._venueFields
                .filter(function (venueField) { return venueField.value; })
                .map(function (venueField) { return parseInt(venueField.key, 10); });
        };
        _this.setOrientation = function (orientation) {
            _this.form.model.orientation = orientation;
            _this.observationProvider.notifyObservers(__1.RoomStatusDisplayPageActions.Loaded);
        };
        _this.toggleVenue = function (venueId) {
            var venueField = _this._venueFields.find(function (field) { return parseInt(field.key, 10) === venueId; });
            if (!venueField) {
                return;
            }
            venueField.setValue(!venueField.value);
        };
        _this.toggleAllVenues = function () {
            var shouldSelectAll = _this._venueFields.some(function (venueField) { return !venueField.value; });
            _this.isBulkUpdatingVenueFields = true;
            for (var _i = 0, _a = _this._venueFields; _i < _a.length; _i++) {
                var venueField = _a[_i];
                venueField.setValue(shouldSelectAll);
            }
            _this.isBulkUpdatingVenueFields = false;
            _this.syncSelectedVenueIds();
            _this.observationProvider.notifyObservers(__1.RoomStatusDisplayPageActions.Loaded);
        };
        _this.isVenueSelected = function (venueId) {
            return _this.form.model.venueIds.indexOf(venueId) !== -1;
        };
        _this.loadData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._isLoading = true;
                        this.observationProvider.notifyObservers(__1.RoomStatusDisplayPageActions.Loading);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, this.api.get(__1.EndpointUrls.Public + '/MeetingDisplay', this.form.model)];
                    case 2:
                        _a._meetingDisplayData = _b.sent();
                        this._meetingDisplayData.currentDateTimeOffset = __1.DateUtils.CreateDateMaintainTimezone(this._meetingDisplayData.currentDateTimeOffset);
                        this.buildGridTimes();
                        if (!this._intervalId) {
                            this._intervalId = setInterval(this.loadData, 60000);
                        }
                        this._settingsVisible = false;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        clearInterval(this._intervalId);
                        this.alert.show({
                            alertType: components_1.AlertType.Error,
                            heading: 'Unable to Load',
                            message: 'TEMS was not able to load meeting data for this display. Refresh this page to try again.'
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.submitButton.setProcessing(false);
                        this.observationProvider.notifyObservers(__1.RoomStatusDisplayPageActions.Loaded);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.buildGridTimes = function () {
            _this._gridTimes = [];
            var currentHour = _this.meetingDisplayData.currentDateTimeOffset.getHours();
            var skipFirst = _this.meetingDisplayData.currentDateTimeOffset.getMinutes() > 30;
            _this._firstGridDateTime = new Date(_this.meetingDisplayData.currentDateTimeOffset.getFullYear(), _this.meetingDisplayData.currentDateTimeOffset.getMonth(), _this.meetingDisplayData.currentDateTimeOffset.getDate(), currentHour, skipFirst ? 30 : 0);
            for (var hour = currentHour; hour < 24; hour++) {
                var prefix = hour < 10 ? '0' : '';
                if (!skipFirst) {
                    _this._gridTimes.push(prefix + hour + '00');
                }
                skipFirst = false;
                _this._gridTimes.push(prefix + hour + '30');
            }
        };
        _this.observationProvider = new __1.ObservationProvider();
        _this._settingsVisible = true;
        _this._form = new __1.Form([
            new components_1.CheckBoxField('displayMeetingList', 'Display Meeting List'),
            new components_1.CheckBoxField('displayMeetingGrid', 'Display Meeting Grid'),
            new components_1.CheckBoxField('displayMeetingName', 'Meeting Name'),
            new components_1.CheckBoxField('displayMeetingNumber', 'Meeting Number'),
            new components_1.CheckBoxField('displayMeetingTime', 'Meeting Time'),
            new components_1.CheckBoxField('displayMeetingPoc', 'Meeting POC')
        ], {
            eventId: eventId,
            passKey: passKey,
            orientation: RoomStatusDisplayOrientation.Horizontal,
            displayMeetingGrid: true,
            displayMeetingList: false,
            displayMeetingName: false,
            displayMeetingNumber: true,
            displayMeetingTime: false,
            displayMeetingPoc: false,
            venueIds: []
        });
        _this.form.observationProvider.observe(_this.loadData, components_1.FormActions.FormSubmitted);
        _this.submitButton = new button_1.default({
            text: 'Show Display',
            onClick: _this.form.submit,
            processingText: 'Loading...'
        });
        _this._venues = [];
        _this._venueFields = [];
        _this._gridTimes = [];
        _this.isBulkUpdatingVenueFields = false;
        _this.loadVenues();
        return _this;
    }
    Object.defineProperty(MeetingPlacardPage.prototype, "firstGridDateTime", {
        get: function () {
            return this._firstGridDateTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "form", {
        get: function () {
            return this._form;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "settingsVisible", {
        get: function () {
            return this._settingsVisible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "meetingDisplayData", {
        get: function () {
            return this._meetingDisplayData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "gridTimes", {
        get: function () {
            return this._gridTimes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "venues", {
        get: function () {
            return this._venues;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "venueFields", {
        get: function () {
            return this._venueFields;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "selectedVenues", {
        get: function () {
            var _this = this;
            return this.venues.filter(function (venue) { return _this.isVenueSelected(venue.id); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeetingPlacardPage.prototype, "selectedMeetings", {
        get: function () {
            var _this = this;
            if (!this.meetingDisplayData) {
                return [];
            }
            return this.meetingDisplayData.meetings.filter(function (meeting) { return _this.isVenueSelected(meeting.venueId); });
        },
        enumerable: false,
        configurable: true
    });
    return MeetingPlacardPage;
}(__1.BasePage));
exports.default = MeetingPlacardPage;
